import { rgba } from 'utils/polished';

import { EDITOR_DANGER_COLOR, EDITOR_DANGER_TEXT_COLOR } from './editorColors';

const spacings = {
  small: '0.5rem', // 8px - theme.space[1]
  normal: '1rem', // 16px - theme.space[2]
  large: '1.5rem', // 24px - theme.space[3]
  extraLarge: '2.5rem', // 40px - theme.space[4]
};

const fontSize = {
  small: '0.75rem', // 12px - theme.fontSize[4]
  normal: '0.875rem', // 14px - theme.fontSize[3]
  middle: '0.9375rem', // 15px - theme.fontSize[2]
  large: '1rem', // 16px - theme.fontSize[1]
  extraLarge: '1.3125rem', // 21px - theme.fontSize[0]
};

const lineHeight = {
  small: '0.875rem', // 14px - theme.lineHeight[4]
  normal: '1.0625rem', // 17px - theme.lineHeight[3]
  middle: '1.125rem', // 18px - theme.lineHeight[2]
  large: '1.1875rem', // 19px - theme.lineHeight[1]
  extraLarge: '1.5625rem', // 25px - theme.lineHeight[0]
};

const EditorTheme = {
  logo: color =>
    `"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'%3e%3cg fill='none' fill-rule='evenodd'%3e%3cpolygon fill='${color}' points='19.299 10.442 21.724 10.442 21.724 21.053 19.299 21.053 19.299 14.883 16.555 19.385 16.282 19.385 13.539 14.883 13.539 21.053 11.113 21.053 11.113 10.442 13.539 10.442 16.419 15.156'/%3e%3crect width='29' height='29' x='1.5' y='1.5' stroke='${color}' stroke-width='3'/%3e%3c/g%3e%3c/svg%3e"`,

  breakpoints: ['768px', '1024px'],

  remSize: '16px',

  fontSize: [fontSize.extraLarge, fontSize.large, fontSize.middle, fontSize.normal, fontSize.small],

  lineHeight: [
    lineHeight.extraLarge,
    lineHeight.large,
    lineHeight.middle,
    lineHeight.normal,
    lineHeight.small,
  ],

  space: ['0', spacings.small, spacings.normal, spacings.large, spacings.extraLarge],

  colors: {
    bodyBackground: '#F6F6F6',
    bodyText: '#8F919E',
    primary: '#27326C',
    danger: EDITOR_DANGER_COLOR,
    dangerText: EDITOR_DANGER_TEXT_COLOR,
    white: '#FFFFFF',
    gray: '#8F919E',
    separator: rgba('#273070', 0.1),
    inputBorder: '#E0E0E0',
    checkboxBorder: '#C7CDD8',
    selectBackground: '#fcfcfc',
    selectText: '#484d58',

    beautyBush: '#EFCCCB',
    buttonSelected: rgba('#FFFFFF', 0.16),
    modalOverlay: rgba('#F3F3F3', 0.8),

    orange: '#F69054',
    yellow: '#FFB900',
    yellowLight: '#FFF6E0',
    green: '#008A7E',

    toolbarArrow: '#D8D8D8',
  },

  buttonSize: {
    normal: `2rem`,
    large: `3rem`,
  },

  opacityDisabled: 0.5,
  boxShadow: `0 0.125rem 0.25rem 0 ${rgba(28, 61, 96, 0.08)}`,
  boxShadowButton: `0 0.125rem 0.25rem 0 ${rgba(28, 61, 96, 0.16)}`,
  boxShadowPanel: `0 0.125rem 0.25rem 0 ${rgba(28, 61, 96, 0.06)}`,
  panelShadow: 'none',
};

export default EditorTheme;
